import { OidcAccessToken } from "@axa-fr/react-oidc/dist/ReactOidc";
import { OidcUserInfo } from "@axa-fr/react-oidc";
import { useBackendUserInfo } from "./useBackendUserInfo";

export const useUserInfo = (
  oidcUserInfo: OidcUserInfo,
  oidcAccessToken: OidcAccessToken,
): {
  userName: string | undefined;
  roles: string[] | undefined;
} => {
  // Try to get user info from backend first
  const { userInfo: backendUserInfo, loading: backendLoading } = useBackendUserInfo();
  
  // If backend user info is available and loaded, use it
  if (!backendLoading && backendUserInfo) {
    return {
      userName: backendUserInfo.name || backendUserInfo.preferred_username,
      roles: backendUserInfo.groups
    };
  }
  
  // Fall back to OIDC token info (for backward compatibility)
  const userName =
    oidcUserInfo?.name ??
    (oidcAccessToken.accessTokenPayload?.name as string | undefined);
  
  // Check for both 'groups' and 'roles' claims (JumpCloud uses 'roles')
  let roles = oidcUserInfo?.groups ?? 
    (oidcAccessToken.accessTokenPayload?.groups as string[] | undefined) ??
    (oidcAccessToken.accessTokenPayload?.roles as string[] | undefined);
  
  // Ensure roles is always an array (JumpCloud sends single role as string)
  if (roles && typeof roles === 'string') {
    roles = [roles];
  }
  
  return { userName: userName, roles: roles };
};
